import { ref } from '@vue/composition-api';

const networkError = ref(false);
const safariMicrophoneChange = ref(false);
export default function useErrors() {
  return {
    networkError,
    safariMicrophoneChange,
  };
}
